// extracted by mini-css-extract-plugin
export default {"from-error":"RegisterForm_from-error__0JX7Q"};